export const UNISWAP_GRANTS = `
`
